import type { ClaimOfferError, ClaimResult } from "@b2bportal/core-media";
import {
  ClaimOfferErrorCode,
  OfferClaimStatus,
} from "@b2bportal/media-ads-api";
import { ClaimStatus } from "./constants";

/** Maps a successful claim result to a tracking `ClaimStatus`. */
export const getClaimStatusFromSuccess = (result: ClaimResult): ClaimStatus => {
  if (result.offerClaimStatus === OfferClaimStatus.UserPreviouslyClaimed) {
    return ClaimStatus.already_claimed;
  }
  return ClaimStatus.claimed;
};

/** Maps a claim error to a tracking `ClaimStatus`. */
export const getClaimStatusFromError = (
  error: ClaimOfferError
): ClaimStatus => {
  if (error.errorCode === ClaimOfferErrorCode.OfferAlreadyClaimed) {
    return ClaimStatus.already_claimed;
  }
  if (error.errorCode === ClaimOfferErrorCode.UserNotEligible) {
    return ClaimStatus.ineligible;
  }
  return ClaimStatus.failed;
};

/** Returns the failure reason string, only when `claim_status` is `failed`. */
export const getClaimFailureReason = (
  claimStatus: ClaimStatus,
  error?: ClaimOfferError
): string | undefined => {
  if (claimStatus !== ClaimStatus.failed) return undefined;
  return error?.errorCode ?? error?.message;
};
